/* eslint-disable react/no-unknown-property */
import { ReactElement, useState } from 'react';
import cn from 'classnames';
import {
  SideNavbarItem,
  SideNavbarItemI,
} from './components/SideNavbarItem/SideNavbarItem';
import styles from './SideNavbar.module.scss';
import { Icon } from '../Icon/Icon';
import { Button } from '../Button/Button';

interface SideNavbarI {
  items: SideNavbarItemI[];
  brandIcon: ReactElement;
  enableHeader?: boolean;
}

export const SideNavbar = ({
  items,
  brandIcon,
  enableHeader = true,
}: SideNavbarI) => {
  const [isExpanded, setIsExpanded] = useState(false);
  // const [isTransitionToExpanded, setIsTransitionToExpanded] = useState(false);
  const renderItems = () =>
    items.map((item) => (
      <SideNavbarItem
        key={`${item.title}-${item.navigateTo}`}
        {...item}
        isExpanded={isExpanded}
      />
    ));

  return (
    <div className={styles.root} color-palette="scheduler-1">
      {enableHeader && (
        <div className={styles.header}>
          <div className={cn(styles.brand, isExpanded && styles.expanded)}>
            {brandIcon}
          </div>
          <div className={styles.icons}>
            <Button
              className={cn(
                styles['pin-button'],
                isExpanded && styles.expanded
              )}
            >
              <Icon classname={styles.icon} type="unpin" />
            </Button>
            <Button
              onClick={() => setIsExpanded((expanded) => !expanded)}
              className={cn(styles.button, isExpanded && styles.expanded)}
            >
              <Icon classname={styles.icon} type="right-arrow" />
            </Button>
          </div>
        </div>
      )}
      {renderItems()}
    </div>
  );
};
